import { api } from "api/apiService";

/**
 * Завантажує список продукції партнерів з урахуванням параметрів.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації, сортування та пагінації.
 * @returns {Promise<object>} Проміс, що повертає об'єкт з даними про продукцію.
 */
export const fetchPartners = (filters = {}) => {
  // Копіюємо лише ті фільтри, які мають значення, для чистоти URL
  const cleanFilters = {};
  for (const key in filters) {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== "") {
      cleanFilters[key] = value;
    }
  }

  return api.get("/partners", cleanFilters);
};

/**
 * Завантажує список всіх доступних типів партнерів.
 * @returns {Promise<Array>} Проміс, що повертає масив об'єктів партнерів.
 */
export const fetchPartnerTypes = () => {
  return api.get("/partners/types");
};

/**
 * Завантажує список всіх доступних властивостей (Готівка/Безготівка).
 * @returns {Promise<Array>} Проміс, що повертає масив об'єктів властивостей.
 */
export const fetchPartnerProperties = () => {
  return api.get("/partners/properties");
};

/**
 * Оновлює кастомні властивості для конкретного товару за його SKU.
 * @param {string} sku - Артикул товару, який потрібно оновити.
 * @param {object} updateData - Об'єкт з полями для оновлення (price, availability, is_active, property_id).
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const updatePartnerProperties = (sku, updateData) => {
  const url = `/partners/${encodeURIComponent(sku)}`;
  return api.patch(url, updateData);
};

/**
 * Видаляє всі кастомні властивості для конкретного товару за його SKU.
 * @param {string} sku - Артикул товару, для якого видаляються налаштування.
 * @returns {Promise<any>} Проміс, що повертає відповідь від сервера.
 */
export const deletePartnerProperties = (sku) => {
  const url = `/partners/${encodeURIComponent(sku)}`;
  return api.delete(url);
};
